import { useState, useEffect, useCallback } from 'react';

// Hooks
import useNotify from '../notify';

// Service
import GeoService from '../../services/countryApiService';

const useGeo = (defaultCountryCode) => {
    const [countries, setCountries] = useState([]);
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [loading, setLoading] = useState(false);

    const { Notify, variants } = useNotify();
    
    const loadStates = useCallback(async (countriesList, countryCode) => {
        const country = countriesList?.find(c => c.code === countryCode);

        if(country) {
            const states = await GeoService.GetState( country.id )
                .catch(() => Notify("Ocurrio un error al obtener las provincias", variants.ERROR));
            setStates(states);
        }
    }, [Notify, variants.ERROR])


    useEffect(() => {
        const initGeo = async () => {
            setLoading(true);
            const countries = await GeoService.GetCountries()          
            .then((res) => {   
               const countries2 =  res.filter(obj => { return obj.code !== "CL" })       
                setCountries(countries2);
            });
            await loadStates(countries, defaultCountryCode);
            setLoading(false);
        }
        initGeo();
    }, [defaultCountryCode, loadStates]);

    const selectCountry = useCallback(async ( countryCode ) => {
        setLoading(true);
        await loadStates(countries, countryCode);
        setLoading(false);
    }, [loadStates, countries])



const selectState = useCallback((stateId) => {
    const state = states.find(s => s.id === stateId)

        if(state) {
            const sorted = [...(state.cities ?? [])].sort((a, b) =>
                a.name.localeCompare(b.name, 'es', { sensitivity: 'base' })
            )
            setCities(sorted)
        }
    }, [states])





    return {
        countries,
        states,
        cities,
        loading,
        selectCountry,
        selectState,
    }
}

export default useGeo;